<template>
  <div>
    <div style="padding-bottom: 1.1rem">
        <router-view />
    </div>
    <van-tabbar  :route="true">
        <van-tabbar-item @click="goToLink(item)" v-for="(item) in tabbarList" :key="item.active" class="align jus">
          <div style="text-align: center">
            <SVGIcon  :class="item.active==$route.name ? 'active-tabbar' : 'normal-tabbar'" :key="item.name"       :name="item.name"></SVGIcon>
          </div>
          <div>{{ item.label }}</div>
        </van-tabbar-item>
    </van-tabbar>
  </div>
</template>


<script>
import {openCustomerServiceChat} from "@/helper/wxprogramSDK"
export default { 
  data() {
    return {
      tabbarList: [
        { label: '首页',  active:"indexPage", link: '/' ,name:"home"},
        { label: '榜单',active:"carrierListLive", link: '/carrierList/live',name:"carrierList" },
        { label: '搜索',active:"search", link: '/search',name:"search" },
        // { label: '客服', active:"openCustomerServiceChat",link: '/openCustomerServiceChat' ,fn:()=>{
        //   openCustomerServiceChat()
        // }  ,name:"customer-service"},
        { label: '我的',active:"my", link: '/my',name:"user" }
      ]
    }
  },
  methods:{
    goToLink(target){
      if(target?.fn){
        target?.fn()
        return
      }else{
         this.$router.push(target.link)
      }
    },
  },
  mounted() {
    wx?.miniProgram.postMessage( { data:{ cookie: document.cookie}})
    const scene = this.$route.query.scene
    if (scene) {
      this.$api.get('v1.1.0/shortLink/' + scene).then(res => {
        this.$router.push(res.redirect)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.active-tabbar,.normal-tabbar{
  height: 18*0.02rem;
  width: 18*0.02rem; 
  margin-bottom: 4*0.02rem;
}
.active-tabbar {
  --stopColor1:#2A89F4;
  --stopColor2:#54BEFA;
  // background-image: url('../static/images/tabbar-select.png')
}

.normal-tabbar {
  --stopColor1:#B1BDCC;
  --stopColor2:#D3E2ED;
  // background-image: url('../static/images/tabbar-unselect.png')
}
</style>

<style lang="less">
.tabbar-icon {
  width: .4rem;
  height: .4rem;
  overflow: hidden;
  background-size: cover;
}


.van-tabbar {
  display: flex;

  a {
    flex: 1;
  }
}
</style>